module.exports = __webpack_public_path__ + "media/images/bg/shapes/cube-e77f1bc942edae4ba54149d13691bc40.svg";